module.exports = __webpack_public_path__ + "static/media/18a.4d63a368.jpg";